"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputPhone = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _objectSpread2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _Input = require("../../../elements/input/Input");
var _react = _interopRequireWildcard(require("react"));
var _inputPhoneModule = _interopRequireDefault(require("./input-phone.module.scss"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Select = require("../../../elements/select/select/Select");
var _countries = require("../../../constants/countries/countries");
var _excluded = ["label", "value", "key"];
/**
 * @deprecated This component is deprecated. Use PhonePicker instead.
 */
var InputPhone = function InputPhone(_ref) {
  var value = _ref.value,
    id = _ref.id,
    onChange = _ref.onChange,
    name = _ref.name,
    className = _ref.className,
    error = _ref.error,
    required = _ref.required,
    disabled = _ref.disabled;
  var handleNumberChange = (0, _react.useCallback)(function (e) {
    onChange((0, _objectSpread2.default)((0, _objectSpread2.default)({}, value), {}, {
      number: e.currentTarget.value
    }), true);
  }, [value, onChange]);
  var handleCountryCodeChange = (0, _react.useCallback)(function (e) {
    var countryCode = _countries.COUNTRY_CODES.find(function (code) {
      return code.key === e.currentTarget.value;
    });
    onChange((0, _objectSpread2.default)((0, _objectSpread2.default)({}, value), {}, {
      countryCode: countryCode.value,
      key: countryCode.key
    }), true);
  }, [value, onChange]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_inputPhoneModule.default['input-phone'], className)
  }, /*#__PURE__*/_react.default.createElement(_Select.Select, {
    id: "".concat(id, "-countryCode"),
    searchable: true,
    className: _inputPhoneModule.default['input-phone__country-code'],
    options: _countries.COUNTRY_CODES.map(function (_ref2) {
      var label = _ref2.label,
        value = _ref2.value,
        key = _ref2.key,
        rest = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
      return (0, _objectSpread2.default)({
        label: "".concat(label, ",+").concat(value),
        value: key
      }, rest);
    }),
    onChange: handleCountryCodeChange,
    value: value.key,
    name: "".concat(name, "-countryCode"),
    required: required,
    disabled: disabled
  }), /*#__PURE__*/_react.default.createElement(_Input.Input, {
    error: error,
    maxLength: 13,
    className: _inputPhoneModule.default['input-phone__number'],
    id: "".concat(id, "-number"),
    name: "".concat(name, "-number"),
    value: value.number,
    onChange: handleNumberChange,
    required: required,
    disabled: disabled
  }));
};
exports.InputPhone = InputPhone;